<template lang="pug">

  transition(
    v-on:enter="enter"
    v-on:leave="leave"
    appear
    )

    #rating-two.content-section

      article.content-inner

        h1 How does a 2-star car crash?

        p A 2-star car has very limited protection for you and your passengers.

        p In a crash, 
          strong you’re 60% more likely to be killed or seriously injured 
          | as you would be in a 5-star car. Safety features like airbags may minimise the forces applied to your body, but will not significantly protect you from harm. The structural features in a 2-star car won’t be capable of absorbing the impact, meaning the energy from a crash is transferred directly into your 
          em survival bubble. 
          | A 2-star car is not recommended.
        
        h3 Next time you are buying, look for the highest star rating in your price range.

</template>

<script>

import { PATHS } from 'src/config/app'
import BaseContentPageMixin from '@/components/content-pages/mixins/BaseContentPage'

export default {

  name: PATHS.RATING_TWO,

  components: { },

  mixins: [
    BaseContentPageMixin
  ],

  data() {
    return { }
  },

  computed: {},

  mounted() {},

  beforeDestroy() {},

  methods: {
  },

  watch: {},

}
</script>

<style lang="sass" scoped>
@import "src/styles/common.sass"
 
</style>
